export default "<!--<p>home-redirect works!</p>-->\r\n"